"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNameInitials = exports.handleEnter = exports.cellSorter = exports.setTimer = exports.getWidth = exports.rem = exports.isNumeric = void 0;

var isNumeric = function isNumeric(value) {
  var convertedValue = parseFloat(value);
  return !Number.isNaN(convertedValue);
}; // convert px to rem


exports.isNumeric = isNumeric;

var rem = function rem(pixel) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 13;
  var value = 0;

  if (isNumeric(pixel) && isNumeric(context)) {
    value = pixel / context;
    var decimal = String(value).split('.')[1];

    if (decimal && decimal.length > 8) {
      value = value.toFixed(8);
    }
  }

  return "".concat(value, "rem");
}; // Get client width


exports.rem = rem;

var getWidth = function getWidth(text) {
  var div = document.createElement('div');
  div.style.display = 'inline-block';
  div.innerHTML = text;
  document.body.appendChild(div);
  var width = div.clientWidth;
  document.body.removeChild(div);
  return width;
}; // Timer


exports.getWidth = getWidth;

var setTimer = function setTimer(callback) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  setTimeout(function () {
    if (typeof callback === 'function') {
      callback();
    }
  }, duration);
}; // sort for table cells that have array data


exports.setTimer = setTimer;

var cellSorter = function cellSorter(accessor, prop) {
  return function (a, b) {
    if (!a.values || !a.values[accessor]) return 0;
    var itemA = a.values[accessor].value;
    var itemB = b.values[accessor].value;

    if (prop) {
      // For sorting data that it's not cell's value
      // such as timestamp
      itemA = a.values[accessor].props[prop];
      itemB = b.values[accessor].props[prop];
    }

    if (typeof itemA === 'string') {
      itemA = itemA.toUpperCase(); // ignore upper and lowercase

      itemB = itemB.toUpperCase(); // ignore upper and lowercase
    }

    if (itemA < itemB) {
      return -1;
    }

    if (itemA > itemB) {
      return 1;
    } // equal


    return 0;
  };
}; // Handle Enter-Key event


exports.cellSorter = cellSorter;

var handleEnter = function handleEnter(e, callback) {
  var key = e.key;

  if (key === 'Enter' && typeof callback === 'function') {
    callback(e);
  }
}; // Get the first letters of fullname


exports.handleEnter = handleEnter;

var getNameInitials = function getNameInitials(fullname) {
  if (!fullname || typeof fullname !== 'string') {
    return '';
  }

  var nameArr = fullname.split(/\s/);

  if (nameArr.length > 1) {
    return "".concat(nameArr[0][0]).concat(nameArr[1][0]);
  }

  return "".concat(nameArr[0][0]).concat(nameArr[0][1]);
};

exports.getNameInitials = getNameInitials;
//# sourceMappingURL=util.js.map